import { Component } from '@angular/core';
import { ArticleSeoComponent } from '../article-seo';
import { ArticleTemplateComponent } from '../article-template/article-template.component';

@Component({
  selector: 'app-article-07',
  imports: [ArticleTemplateComponent],
  templateUrl: './article-07.component.html',
  styleUrls: []
})
export class Article07Component extends ArticleSeoComponent {
  protected readonly seo = {
    pageTitle: 'Leilão judicial vs extrajudicial: qual a diferença? | Casato Brasil',
    description: 'Entenda as diferenças entre leilão judicial e extrajudicial, como cada processo funciona e quais cuidados analisar antes do lance.'
  };
}
